import { memo } from 'react';

import SectionHeading from '@/pages/Profile/components/SectionHeading';

import {
  AddressSection,
  AppLoginEmailSection,
  EmailSection,
  EmergencyContactSection,
  PhoneNumberSection
} from './components';

const ContactInfoSection = () => {
  return (
    <div>
      <SectionHeading text="Contact Info" />

      <AppLoginEmailSection />
      <EmailSection />
      <PhoneNumberSection />
      <AddressSection />
      <EmergencyContactSection />
    </div>
  );
};

export default memo(ContactInfoSection);
